export default __webpack_public_path__ + "static/media/Town31Dim-Black.81fb4f35.ttf";